import { Text } from '@/components/ui/text';
import { Pressable } from '@/components/ui/pressable';
import { HStack } from '@/components/ui/hstack';
import { useNavigation } from '@react-navigation/native';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import i18n from 'i18n-js';
import { IconMC } from '../media/IconsV2';
import { Alert } from 'react-native';

export default function RichText({ text, onPress, flat, className }) {
    const regex = /([^\[\*]*)((\[([^\]]*)\]\(([^)]+)\))|(\*\*([^*]+)\*\*))([^\[\*]*)/g;

    /*
Match 0: Gesamter Match
Match 1: Text Prefix
Match 2: Link oder Fett
Match 3: Link (optional, nur wenn Match 2 ein Link ist) - ignored
Match 4: Link Text (optional, nur wenn Match 2 ein Link ist)
Match 5: Link URL (optional, nur wenn Match 2 ein Link ist)
Match 6: Fett (optional, nur wenn Match 2 fett ist) - ignored
Match 7: Fett Text (optional, nur wenn Match 2 fett ist)
Match 8: Text Suffix
*/

    const workflows = useSelector((state) => state.workflows);
    const navigation = useNavigation();
    const [comps, setComps] = useState([{ type: 'text', text }]);

    const richText = (text) => {
        let match;
        let parts = [];
        while ((match = regex.exec(text)) !== null) {
            // console.log('Match:', match[2].startsWith('[') ? 'Link' : 'Fett', match[7]);
            if (match[1] != '') {
                parts.push({ type: 'text', text: match[1] }); // Vor dem Link oder Fett
            }
            if (match[2].startsWith('[')) {
                parts.push({ type: 'link', text: match[4] || match[5], link: match[5] }); // Link
            } else {
                parts.push({ type: 'bold', text: match[7] }); // Fett
            }
            if (match[8] != '') {
                parts.push({ type: 'text', text: match[8] }); // Nach dem Link oder Fett
            }
        }
        return parts
    };

    useEffect(() => {
        const parts = richText(text);
        setComps(parts.length > 0 ? parts : [{ type: 'text', text }]);
    }, [text]);

    const selectTask = (text) => {
        for (const taskid in workflows) {
            const workflow = workflows[taskid];
            if (workflow.title.toLowerCase().includes(text.toLowerCase())) {
                console.log('Link pressed', workflow.id, workflow.title);
                navigation.push('ShowWorkflow2', { taskid: workflow.id, isLoading: false });
                return;
            }
        }
        Alert.alert(i18n.t('global.warning'), i18n.t('message.notFound', { title: text }), [{ text: 'OK', onPress: () => {} }]);
    };

    const LinkText = ({ comp }) => (
        <>
            <IconMC className="text-sm text-secondary-900" name="link-variant" />
            <Text className={`text-2xl text-secondary-900 ${className}`}>{comp.text}</Text>
        </>
    );

    const LinkButton = ({ comp }) => (
        <Pressable onPress={() => selectTask(comp.link)} className="w-auto pl-2 pr-2 bg-primary-900 rounded-lg overflow-hidden">
            <HStack className="items-center">
                <IconMC className="text-lg text-secondary-50" name="link-variant" />
                <Text className="text-xl leading-7 text-secondary-50 ">{comp.text}</Text>
            </HStack>
        </Pressable>
    );

    return (
        <Text onPress={onPress} className={`${flat ? 'line-clamp-2' : 'mt-2'} text-2xl text-secondary-900 ${className}`}>
            {comps.map((comp, index) => {
                if (comp.type == 'text') {
                    return (
                        <Text key={index} className={`text-2xl text-secondary-900 ${className}`}>
                            {comp.text}
                        </Text>
                    );
                } else if (comp.type == 'bold') {
                    return (
                        <Text key={index} className={`text-2xl font-bold text-secondary-900 ${className}`}>
                            {comp.text}
                        </Text>
                    );
                } else if (comp.type == 'link') {
                    return flat ? <LinkText key={index} comp={comp} /> : <LinkButton key={index} comp={comp} />;
                }
            })}
        </Text>
    );
}
